import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  Box,
  Grid,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React, {useState} from "react";
import "./ProductCard.css";
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import Cart from "./Cart"

const ProductCard = ({ product,items,handleAddToCart }) => {

  // console.log(" Inside Product Card :: ",product);
  // console.log(" Inside Product Card :: ",product);
 let token = localStorage.getItem("token");
  return (

   <Grid container spacing={2} p={1}>
    {(product) &&
  (product.map(productData => {
    const {_id, name, category, image, cost, rating} = productData;

    return (

  <Grid item key={_id} xs={12} sm={6} md={3} 
  // m={1}
  >
    <Card  className="card">
     <CardMedia
    //  sx={{ height: 150 }}
      component="img"
      image={image}
      alt={name}
    />
    <CardContent>
      <h3>{name}</h3>
      <h3>${cost}</h3>
      <Rating name="read-only" value={rating} readOnly />
    </CardContent>
    <Button sx={{ m: 1 }} variant="contained"  onClick={()=>{
      
      handleAddToCart(token,items,product,_id,1, true);
    }}
    ><AddShoppingCartIcon sx={{ mr: 1 }}/>
    
    ADD TO CART</Button>
  
  </Card>
 </Grid>

 )
  }))
  // (<Box
  //   display="flex"
  //   width="100vw"
  //   height="50vh"
  //   sx={{"flex-direction":"column" ,  "justify-content":"center" , "align-items":"center" }}>
  //      <SentimentVeryDissatisfiedIcon />
  //      <h6>No products found</h6>
  //   </Box>)
  // (<Grid item key={1} xs={12} sm={6} md={3}>
  // <Card className="card">
  //    <CardMedia
  //     component="img"
  //     height="194"
  //     image="Empty"
  //     alt="Empty"
  //   />
  //   <CardContent>
  //     <h3>Empty</h3>
  //     <h3>$0</h3>
  //     <Rating name="read-only" value={1} readOnly />
  //   </CardContent>
  //   <Button sx={{ m: 1 }} variant="contained"><AddShoppingCartIcon sx={{ mr: 1 }}/>ADD TO CART</Button>
  // </Card>
  // </Grid>
  // ) 
}
   </Grid>
  );
};

export default ProductCard;
